import { Card } from '@ecom/ui-kit';
import { type ReactElement } from 'react';

/**
 * Mirrors apps/merchant-dashboard's own `dashboard/components/KpiCard.tsx`
 * exactly — a plain `value`/`hint` card, no "soon" state here: every field
 * this app renders has a real, built backend (this app's own `nav.ts`
 * header states the same for its two existing screens). Not shared as a
 * package: the same "mirror, don't couple" posture already applied to
 * `ToastProvider`/`TableSkeleton` between the two dashboards.
 */
export interface KpiCardProps {
  readonly label: string;
  readonly value: string;
  readonly hint?: string;
}

export function KpiCard({ label, value, hint }: KpiCardProps): ReactElement {
  return (
    <Card className="p-4">
      <p className="text-xs font-medium uppercase tracking-wide text-inkFaint">{label}</p>
      <p className="mt-1.5 font-display text-2xl font-bold text-ink">{value}</p>
      {hint !== undefined ? <p className="mt-0.5 text-xs text-inkFaint">{hint}</p> : null}
    </Card>
  );
}
